export type NavigationItem = {
    title: string;
    path?: string;
    icon?: string;
    type?: string;
    children?: Array<GroupItem | ChildItem>;
};

export interface ChildItem {
    title: string;
    path: string;
    icon: string;
    type: string;
    children?: ChildItem[];
}

export interface GroupItem {
    title: string;
    icon: string;
    path?: string;
    type: string;
    children: ChildItem[];
}

const navigationConfig: NavigationItem[] = [
    {
        title: 'Home',
        path: '/',
        icon: 'home',
        type: 'link'
    },
    {
        title: 'Vehicle',
        path: '/vehicle',
        icon: 'car',
        type: 'link'
    },
    {
        title: 'Trips',
        path: '/trips',
        icon: 'road',
        type: 'link'
    },
    {
        title: 'Contact Us',
        path: '/contact-us',
        icon: 'phone',
        type: 'link'
    },
    {
        title: 'How it works',
        path: '/how-it-works',
        icon: 'cogs',
        type: 'link'
    }
    // {
    //     title: 'Trips',
    //     icon: 'road',
    //     type: 'group',
    //     children: [
    //         {
    //             title: 'Service 1',
    //             icon: 'cogs',
    //             type: 'group',
    //             children: [
    //                 {
    //                     title: 'Sub Service 1',
    //                     path: '/sub-service-1',
    //                     icon: 'cogs',
    //                     type: 'link'
    //                 },
    //                 {
    //                     title: 'Sub Service 2',
    //                     path: '/sub-service-2',
    //                     icon: 'cogs',
    //                     type: 'link'
    //                 },
    //                 {
    //                     title: 'Sub Service 3',
    //                     path: '/sub-service-3',
    //                     icon: 'cogs',
    //                     type: 'link'
    //                 }
    //             ],
    //         },
    //         {
    //             title: 'Service 2',
    //             path: '/service-2',
    //             icon: 'cogs',
    //             type: 'link'
    //         },
    //         {
    //             title: 'Service 3',
    //             path: '/service-3',
    //             icon: 'cogs',
    //             type: 'link'
    //         }
    //     ]
    // },
]

export default navigationConfig;